module.exports = __webpack_public_path__ + "fa-solid-900.e7f19ca67a615cf1b46937d0fb06f8df.ttf";